// 玩家/状态实例的 id 生成（无 crypto 依赖的简易实现）
let counter = 0;

export function nextId(prefix = "id"): string {
  counter += 1;
  return `${prefix}-${counter}-${Date.now().toString(36)}`;
}

export function resetIdCounter(): void {
  counter = 0;
}
